var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeoSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-20 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 1.9,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.35 176.72C87.99 176.72 80.66 169.72 80.66 157.94C80.66 142.25 96.07 104.74 96.07 92.0802C96.07 82.5902 92.07 75.3702 82.36 75.3702C72.65 75.3702 66.9 82.0702 66.9 89.3702C66.9 99.8302 76.84 115.89 76.84 123.95C76.84 140.66 65.47 149.67 51.03 149.67C33.94 149.67 24.77 136.37 24.77 124.4C24.77 111.74 33.36 97.2502 54.9 100.8C52.63 96.6202 51 92.6102 51 84.0902C51 71.0002 62.2 59.9102 82.24 59.9102C102.28 59.9102 112.9 74.1502 112.9 91.1202C112.9 105.46 97.38 143.71 97.38 154.53C97.38 157.88 100.14 160.08 104.69 160.08C109.69 160.08 116.09 157.55 118.69 156.08C119.8 158.9 124.9 165.58 124.9 165.58C120.29 170.35 108.59 176.72 101.35 176.72ZM58.59 116C52.48 114.58 41.91 114.72 41.91 124.53C41.91 129.23 46.43 134.05 51.11 134.05C63.48 134 60.61 118.6 58.59 116Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeoSvgrepoCom);
export default __webpack_public_path__ + "static/media/leo-svgrepo-com.95d2230c2c1dda3656beb5e20c9ad6da.svg";
export { ForwardRef as ReactComponent };